export default __webpack_public_path__ + "static/media/sound-icon.f1357f85.svg";